module.exports = __webpack_public_path__ + "img/wx.8ef81050.png";